import React from "react";
import * as styles from "./DetailsOutstanding.module.scss";
import DetailsItem from "../Details/DetailsItem";

const DetailsOutstanding = ({ Outstanding, colorCategory, featured_image }) => {
  return (
    <>
      {Outstanding ? (
        <div className={styles.detailsOutstanding__container}>
          <div className={styles.characteristics_container}>
            {Outstanding.map((e) => {
              return (
                <DetailsItem
                  icon={e.thumbnail}
                  name={e.name}
                  description={e.description}
                  colorCategory={colorCategory}
                />
              );
            })}
          </div>
          <div className={styles.characteristicsImg_container}>
            {featured_image.map((imageUrl, index) => (
              <img
                key={index}
                src={imageUrl}
                alt={`Peabody destacados ${index + 1}`}
                className={styles.featured_img}
              />
            ))}
          </div>
        </div>
      ) : null}
    </>
  );
};

export default DetailsOutstanding;
